import AssetStatements from "../components/AssetStatements";

const AssetStatementsPage = () => {
  return (
    <section className="">
      {/* <TopMenuStrip /> */}
     <AssetStatements/>
    </section>
  );
};

export default AssetStatementsPage;